import { ModalFooter } from "@hostingbv/lib/src/components/layout/ModalProvider";
import { FC, useState } from "react";
import { config as appConfig } from "../config";
import { useApiClient } from "@hostingbv/lib/src/api";
import { useRefresh } from "@hostingbv/lib/src/components/RefreshController";
import { Site } from "@hostingbv/lib/src/api/partner/models/Site";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";

export const EditSitePhpConfigModal: FC<{ entity: Site }> = (props) => {
  const { partnerClient } = useApiClient(appConfig)
  const refresh = useRefresh()
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!

  const [error, setError] = useState<string>("")
  const [config, setConfig] = useState(props.entity.deploymentDetails?.additionalPhpSettings ?? "")

  const save = async () => {
    const deployment = await partnerClient.updateSitePhpConfig(props.entity.id, config).then(result => {
      if (!result.success) {
        setError(result.error)
        throw new Error(result.error)
      }
      return result.data
    })
    const updatedDeployment = await awaitNextDeploymentFinished(deployment.id)
    if (updatedDeployment?.status === "failed") {
      // @ts-expect-error output's shape isn't statically typed on Deployment
      setError(updatedDeployment?.output?.message ?? 'Invalid configuration')
      throw new Error('Invalid configuration')
    } else {
      refresh()
    }
  }

  return <>
    <form onSubmit={() => save()} className={""}>
      <label>
        <span className={'text-sm font-medium text-blue-900'}>custom_php.ini</span>
        <textarea
          autoFocus={true}
          className={`border-2 border-slate-200 outline-blue-700 text-black rounded-sm font-normal px-2 py-2 mt-1 h-72 text-xs font-mono w-full`}
          placeholder={'max_input_vars=3000'}
          value={config}
          onChange={(e) => setConfig(e.target.value)}
        />
        {error !== "" && <div className={"px-3 py-2 bg-red-50 rounded-sm my-4 text-sm text-red-900"}>
          {error}
        </div>}
      </label>
      <ModalFooter text={"Save"} onSubmit={save} />
    </form>
  </>
}
